import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  fr: {
    translation: {
      nav: {
        home: 'Accueil',
        services: 'Fonctionnalités',
        pricing: 'Pour qui ?',
        api: 'Parcours',
        about: 'À propos',
        contact: 'Contact',
        login: 'Connexion',
        register: 'Créer un compte',
      },
      hero: {
        badge: 'Pour les vendeurs en ligne',
        title: 'La plateforme pensée pour vendre vos produits numériques',
        title_1: 'La plateforme pensée pour',
        title_2: 'vendre vos',
        title_3_a: 'produits',
        title_3_b: '',
        title_3_c: 'numériques',
        subtitle: "Créez, vendez et développez votre activité en ligne avec des outils simples pour présenter vos produits, partager vos offres et faciliter l’encaissement de vos ventes.",
        cta_start: 'Commencer à vendre',
        cta_discover: 'Découvrir Biz-transPay',
         secure: 'Données protégées',
        balance: 'Ventes du mois',
        recent: 'Activité récente',
        see_all: 'Voir tout',
        proof_1: 'Partagez vos offres',
        proof_2: 'Encaissez vos ventes',
        proof_3: 'Suivez vos résultats',
        quick_sell: 'Vendre',
        quick_link: 'Lien',
        quick_track: 'Suivi',
        quick_share: 'Partager',
        sale_received: 'Vente reçue',
        product_order: 'Commande digitale',
        shared_link: 'Lien partagé',
        subscription: 'Abonnement',
      },
      auth: {
        eyebrow: 'Votre activité numérique',
        title: 'Un espace clair pour vendre en ligne',
        body: 'Présentez vos offres, partagez vos liens et suivez vos ventes depuis un espace pensé pour votre activité.',
        point_1: 'Vendre en ligne', point_2: 'Partager vos offres', point_3: 'Suivre vos ventes',
      },
      features: {
        title: 'Tout pour votre activité en ligne',
        subtitle: 'Des outils simples pour présenter vos offres, encaisser vos ventes et suivre votre activité depuis un seul espace.',
        f1_t: 'Vendre en ligne', f1_d: 'Présentez vos produits numériques et permettez à vos clients de découvrir facilement vos offres.',
        f2_t: 'Créer des liens de vente', f2_d: 'Créez des liens pour présenter et vendre vos produits directement à vos clients.',
        f3_t: 'Faciliter l’encaissement', f3_d: 'Proposez à vos clients les moyens de paiement disponibles pour régler leurs achats.',
        f4_t: 'Suivre vos ventes', f4_d: 'Retrouvez vos transactions et suivez l’activité liée à vos ventes depuis votre espace.',
        f5_t: 'Gérer vos revenus de vente', f5_d: 'Centralisez les informations relatives aux paiements reçus pour vos produits et services.',
        f6_t: 'Développer votre activité', f6_d: 'Utilisez des outils numériques conçus pour accompagner la croissance de votre activité en ligne.',
      },
      products: {
        eyebrow: 'Vos offres',
        title: 'Ce que vous pouvez vendre',
        subtitle: 'Présentez vos produits et services numériques au même endroit, avec un parcours clair pour vos clients.',
        p1: 'E-books', p2: 'Formations en ligne', p3: 'Cours numériques',
        p4: 'Logiciels et applications', p5: 'Abonnements numériques', p6: 'Fichiers et ressources numériques',
        p7: 'Services digitaux', p8: 'Contenus numériques', p9: 'Produits téléchargeables',
      },
      audience: {
        eyebrow: 'Pour votre activité',
        title: 'Une solution pour les entrepreneurs numériques',
        subtitle: 'Biz-transPay s’adresse aux créateurs, formateurs, e-commerçants, prestataires de services, développeurs et entrepreneurs qui souhaitent vendre leurs produits ou services numériques en ligne.',
        a1: 'Créateurs de contenu', a2: 'Formateurs', a3: 'E-commerçants', a4: 'Vendeurs d’e-books',
        a5: 'Développeurs', a6: 'Prestataires digitaux', a7: 'Entrepreneurs', a8: 'Créateurs de services en ligne',
      },
      steps: {
        eyebrow: 'Votre parcours de vente',
        title: 'Simplifiez votre parcours de vente',
        subtitle: 'Vendre, partager, encaisser et suivre vos ventes depuis un même espace.',
        s1_t: 'Créez votre compte', s1_d: 'Inscrivez-vous et configurez votre espace.',
        s2_t: 'Présentez votre produit', s2_d: 'Ajoutez votre produit ou votre offre numérique.',
        s3_t: 'Partagez votre lien', s3_d: 'Partagez votre page ou votre lien de vente avec vos clients.',
        s4_t: 'Recevez et suivez vos ventes', s4_d: 'Facilitez l’encaissement de vos ventes et suivez vos transactions depuis votre espace.',
      },
      methods: { title: 'Des moyens de paiement pour vos clients', subtitle: 'Proposez les options disponibles pour faciliter l’encaissement de vos ventes.' },
      stats: {
         badge: 'Pour les vendeurs en ligne',
         title: 'Une base solide pour développer vos ventes',
        users: 'Vendeurs accompagnés',
        partners: 'Activités en ligne',
        tx: 'Ventes suivies',
        uptime: 'Disponibilité de service',
        support: 'Un support disponible pour votre activité',
      },
      security: {
        badge: 'Pensé pour votre activité',
        title: 'Un cadre fiable pour vos ventes en ligne',
         subtitle: 'Vos données, vos offres et les informations liées à vos ventes bénéficient de contrôles adaptés à votre activité numérique.',
        s1: 'Chiffrement des données',
        s2: 'Vérification KYC',
        s3: 'Authentification 2FA',
        s4: 'Protection anti-fraude',
        s5: 'Surveillance des transactions',
      },
      policy: {
        title: 'Utilisation interdite',
         body: "Les systèmes de Ponzi, les activités frauduleuses, le blanchiment d’argent et toute activité illégale sont strictement interdits.",
        warn: 'Toute violation entraîne le blocage automatique du compte.',
      },
      cta: {
        title: 'Prêt à commencer à vendre en ligne ?',
        subtitle: 'Créez votre espace Biz-transPay et donnez à vos produits numériques un parcours de vente simple.',
        button: 'Commencer à vendre',
      },
      footer: {
        tagline: 'La plateforme pensée pour les créateurs, entrepreneurs et vendeurs de produits numériques.',
        products: 'Pour vendre en ligne', company: 'Entreprise', resources: 'Ressources', contact: 'Contact',
        services: 'Fonctionnalités', links: 'Liens de vente', api: 'API', docs: 'Documentation',
        pricing: 'Pour qui ?', about: 'À propos', security: 'Sécurité',
        help: "Centre d'aide", faq: 'FAQ', terms: "Conditions d'utilisation", privacy: 'Politique de confidentialité',
        rights: 'Tous droits réservés.',
      },
      register: {
        title: 'Créer un compte',
        subtitle: 'Créez votre espace Biz-transPay et développez votre activité en ligne avec des outils simples pour vendre vos offres.',
        full_name: 'Nom complet', full_name_ph: 'Entrez votre nom complet',
        username: "Nom d'utilisateur", username_ph: "Choisissez un nom d'utilisateur",
        country: 'Pays', country_ph: 'Sélectionnez votre pays',
        phone: 'Numéro de téléphone', phone_ph: '07 12 34 56 78',
        email: 'Adresse e-mail', email_ph: 'exemple@email.com',
        password: 'Mot de passe', password_ph: 'Créez un mot de passe',
        confirm: 'Confirmer le mot de passe', confirm_ph: 'Confirmez votre mot de passe',
        robot: 'Je confirme ne pas être un robot',
        terms_1: "J'accepte les",
        terms_link_1: "Conditions d'utilisation",
        terms_and: 'et la',
        terms_link_2: 'Politique de confidentialité',
        terms_end: 'de Biz-transPay.',
        submit: 'Créer mon compte',
        have_account: 'Déjà un compte ?',
        login: 'Se connecter',
        errors: {
          required: 'Ce champ est requis', mismatch: 'Les mots de passe ne correspondent pas',
          short: '6 caractères minimum', terms: 'Vous devez accepter les conditions',
          robot: 'Veuillez confirmer que vous n\'êtes pas un robot',
        },
      },
      login: {
        title: 'Connexion',
        subtitle: 'Bon retour parmi nous ! Connectez-vous à votre compte Biz-transPay.',
        identifier: 'Adresse e-mail ou nom d’utilisateur',
        password: 'Mot de passe',
        submit: 'Se connecter',
        no_account: 'Vous n\'avez pas de compte ?',
        register: 'Créer un compte',
      },
      dashboard: {
        title: 'Tableau de bord',
        available: 'Solde disponible',
        transactions: 'Transactions',
        history: 'Historique',
        bottom_home: 'Accueil',
        services: 'Services',
        profile: 'Profil',
        payment_link: 'Lien de paiement',
        api: 'API de paiement',
        kyc: 'Vérification KYC',
        fees: 'Frais',
        settings: 'Paramètres',
        support: 'Support',
        transfer: 'Transfer', deposit: 'Dépôt', link: 'Lien', exchange: 'Échange',
        search_ph: 'Rechercher par numéro de paiement, ID de transaction, e-mail, référence Biz-transPay ou référence prestataire...',
        kyc_banner_title: 'Vérification KYC requise',
        kyc_banner_body: 'Votre compte a été créé avec succès. Pour des raisons de sécurité et de conformité, vous devez compléter votre vérification KYC avant d\'accéder aux Liens de paiement et à l\'API de paiement.',
        kyc_banner_cta: 'Vérifier mon identité',
        no_tx: 'Aucune transaction pour l\'instant',
        recent_activity: 'Activité récente',
      },
      transfer: {
        title: 'Nouveau transfert',
        subtitle: 'Choisissez le type de transfert que vous souhaitez effectuer.',
        biz_to_biz: 'Biz-trans → Biz-trans', biz_to_biz_d: 'Vers un autre utilisateur Biz-transPay',
        biz_to_mobile: 'Biz-trans → Mobile Money', biz_to_mobile_d: 'Vers un numéro Mobile Money',
        biz_to_bank: 'Biz-trans → Compte bancaire', biz_to_bank_d: 'Vers un compte bancaire (IBAN)',
        recipient: 'Destinataire',
        recipient_ph_biz: "Nom d'utilisateur ou email",
        recipient_ph_mobile: 'Numéro Mobile Money',
        recipient_ph_bank: 'IBAN / numéro de compte',
        recipient_name: 'Nom du destinataire',
        amount: 'Montant', currency: 'Devise', description: 'Description (optionnel)',
        confirm: 'Envoyer le transfert', success: 'Transfert envoyé avec succès !',
        fee: 'Frais',
      },
      deposit: {
        title: 'Effectuer un dépôt',
        subtitle: 'Rechargez votre solde Biz-transPay via Stripe.',
        method: 'Moyen de paiement',
        card: 'Carte bancaire',
        card_d: 'Visa, Mastercard, American Express',
        proceed: 'Continuer vers le paiement',
        min: 'Montant minimum : 300',
      },
      exchange: {
        title: 'Échange de devises',
        subtitle: 'Convertissez vos fonds entre XOF et XAF.',
        from: 'De', to: 'Vers', amount: 'Montant',
        rate: 'Taux de change', fee: 'Frais', receive: 'Vous recevez',
        confirm: 'Confirmer l\'échange', success: 'Échange effectué avec succès !',
      },
      links: {
        title: 'Liens de paiement',
        subtitle: 'Créez et gérez vos liens de paiement.',
        create: 'Créer un lien',
        new_title: 'Nouveau lien de paiement',
        link_title: 'Titre du lien', link_title_ph: 'Ex: Facture #001',
        amount: 'Montant', currency: 'Devise', description: 'Description',
        expires: 'Date d\'expiration (optionnel)',
        single_use: 'Lien à usage unique',
        generate: 'Générer le lien',
        copied: 'Lien copié dans le presse-papier',
        no_links: 'Aucun lien de paiement pour l\'instant',
        payments: 'paiements',
        active: 'Actif', inactive: 'Inactif',
        actions: 'Actions',
      },
      api: {
        title: 'API de paiement',
        subtitle: 'Intégrez Biz-transPay à votre application.',
        public: 'Clé publique', secret: 'Clé secrète',
        webhook: 'URL Webhook', webhook_ph: 'https://votresite.com/webhook',
        regenerate: 'Régénérer les clés', save_webhook: 'Enregistrer',
        copied: 'Copié !',
        docs: 'Documentation API',
        merchant_only: 'Réservé aux comptes marchands. Passez en compte marchand depuis Paramètres.',
      },
      kyc: {
        title: 'Vérification KYC',
        subtitle: 'Complétez votre vérification d\'identité pour accéder à toutes les fonctionnalités.',
        status: 'Statut',
        not_started: 'Non commencé', pending: 'En cours', verified: 'Vérifié', rejected: 'Rejeté',
        doc_type: 'Type de document',
        id_card: 'Carte d\'identité', passport: 'Passeport', driver: 'Permis de conduire',
        doc_number: 'Numéro du document',
        doc_front: 'Recto', doc_back: 'Verso',
        selfie: 'Selfie avec document',
        address_proof: 'Justificatif de domicile',
        address: 'Adresse', city: 'Ville',
        submit: 'Soumettre pour vérification',
        success: 'Vérification KYC soumise et approuvée !',
      },
      settings: {
        title: 'Paramètres', profile: 'Profil', security_t: 'Sécurité', preferences: 'Préférences',
        full_name: 'Nom complet', email: 'Email', phone: 'Téléphone',
        save: 'Enregistrer', saved: 'Enregistré',
        current_pwd: 'Mot de passe actuel', new_pwd: 'Nouveau mot de passe',
        change_pwd: 'Changer le mot de passe',
        two_fa: 'Authentification à deux facteurs (2FA)',
        language: 'Langue', default_currency: 'Devise par défaut',
      },
      support: {
        title: 'Support', subtitle: 'Notre équipe est là pour vous aider.',
        new_ticket: 'Nouveau ticket', subject: 'Sujet', message: 'Message', category: 'Catégorie',
        submit: 'Envoyer',
        no_tickets: 'Aucun ticket pour l\'instant',
        faq_title: 'Questions fréquentes',
      },
      fees: {
        title: 'Frais de la plateforme',
        subtitle: 'Frais actuellement configurés pour la plateforme.',
        deposit: 'Dépôts', withdrawal: 'Retraits', mobile_money: 'Mobile Money',
        crypto: 'Crypto', conversion: 'Conversions', operator: 'Opérateur',
        asset: 'Actif', fee: 'Frais', limits: 'Limites',
        no_data: 'Aucun frais actif n’est configuré.',
        fixed: 'fixe', from: 'à partir de', to: 'jusqu’à', unavailable: 'Indisponible',
      },
      push: {
        title: 'Activez les notifications',
        body: 'Activez les notifications push pour recevoir les informations importantes, les mises à jour et les alertes de votre compte Biz-transPay.',
        allow: 'Activer les notifications',
        later: 'Plus tard',
        enabled: 'Notifications activées',
        error: 'Impossible d’activer les notifications. Réessayez ou activez-les depuis votre profil.',
        blocked: 'Les notifications sont bloquées dans les réglages du navigateur. Autorisez-les dans votre navigateur, puis réessayez depuis votre profil.',
      },
      common: {
        back: 'Retour', next: 'Suivant', cancel: 'Annuler', confirm: 'Confirmer',
        copy: 'Copier', logout: 'Déconnexion',
      },
    },
  },
  en: {
    translation: {
       nav: { home: 'Home', services: 'Features', pricing: 'Who is it for?', api: 'Journey', about: 'About', contact: 'Contact', login: 'Log in', register: 'Sign up' },
      hero: {
        badge: 'For online sellers',
        title: 'The platform built to sell your digital products',
        title_1: 'The platform built to',
        title_2: 'sell your',
        title_3_a: 'digital', title_3_b: '', title_3_c: 'products',
        subtitle: 'Create, sell and grow your online business with simple tools to showcase your products, share your offers and make it easier to collect sales.',
        cta_start: 'Start selling', cta_discover: 'Discover Biz-transPay',
        secure: 'Data protected', balance: 'Monthly sales', recent: 'Recent activity', see_all: 'See all',
        proof_1: 'Share your offers', proof_2: 'Collect your sales', proof_3: 'Track your results',
        quick_sell: 'Sell', quick_link: 'Link', quick_track: 'Track', quick_share: 'Share',
        sale_received: 'Sale received', product_order: 'Digital order', shared_link: 'Shared link', subscription: 'Subscription',
      },
      auth: {
        eyebrow: 'Your digital business',
        title: 'A clear space to sell online',
        body: 'Showcase your offers, share your links and track your sales from a workspace designed for your business.',
        point_1: 'Sell online', point_2: 'Share your offers', point_3: 'Track your sales',
      },
      features: {
        title: 'Everything for your online business', subtitle: 'Simple tools to showcase your offers, collect sales and track your activity from one place.',
        f1_t: 'Sell online', f1_d: 'Showcase your digital products and help customers discover your offers easily.',
        f2_t: 'Create sales links', f2_d: 'Create links to present and sell your products directly to customers.',
        f3_t: 'Make collecting sales easier', f3_d: 'Offer your customers the available ways to pay for their purchases.',
        f4_t: 'Track your sales', f4_d: 'Find your transactions and follow sales activity from your workspace.',
        f5_t: 'Manage sales revenue', f5_d: 'Keep information about payments received for your products and services in one place.',
        f6_t: 'Grow your business', f6_d: 'Use digital tools designed to support the growth of your online business.',
      },
      products: {
        eyebrow: 'Your offers',
        title: 'What you can sell',
        subtitle: 'Showcase your digital products and services in one place, with a clear journey for your customers.',
        p1: 'E-books', p2: 'Online courses', p3: 'Digital courses',
        p4: 'Software and apps', p5: 'Digital subscriptions', p6: 'Digital files and resources',
        p7: 'Digital services', p8: 'Digital content', p9: 'Downloadable products',
      },
      audience: {
        eyebrow: 'For your business',
        title: 'A solution for digital entrepreneurs',
        subtitle: 'Biz-transPay is for creators, trainers, online sellers, service providers, developers and entrepreneurs who want to sell their digital products or services online.',
        a1: 'Content creators', a2: 'Trainers', a3: 'Online sellers', a4: 'E-book sellers',
        a5: 'Developers', a6: 'Digital providers', a7: 'Entrepreneurs', a8: 'Online service creators',
      },
      steps: {
        eyebrow: 'Your sales journey',
        title: 'Simplify your sales journey',
        subtitle: 'Sell, share, collect and track your sales from one workspace.',
        s1_t: 'Create your account', s1_d: 'Sign up and configure your workspace.',
        s2_t: 'Present your product', s2_d: 'Add your digital product or offer.',
        s3_t: 'Share your link', s3_d: 'Share your page or sales link with your customers.',
        s4_t: 'Receive and track your sales', s4_d: 'Make it easier to collect sales and track your transactions from your workspace.',
      },
      methods: { title: 'Payment options for your customers', subtitle: 'Offer available options to make collecting sales easier.' },
      stats: { badge: 'For online sellers', title: 'A solid base for growing your sales', users: 'Sellers supported', partners: 'Online businesses', tx: 'Sales tracked', uptime: 'Service uptime', support: 'Support for your business' },
      security: { badge: 'Built for your business', title: 'A reliable framework for online sales', subtitle: 'Your data, offers and sales information are supported by controls suited to a digital business.',
        s1: 'Data encryption', s2: 'KYC verification', s3: '2FA authentication', s4: 'Anti-fraud protection', s5: 'Transaction monitoring' },
      policy: { title: 'Prohibited use', body: 'Ponzi schemes, fraudulent activities, money laundering and any illegal activity are strictly forbidden.', warn: 'Any violation will lead to automatic account suspension.' },
      cta: { title: 'Ready to start selling online?', subtitle: 'Create your Biz-transPay workspace and give your digital products a simple sales journey.', button: 'Start selling' },
      footer: { tagline: 'The platform built for creators, entrepreneurs and digital product sellers.',
        products: 'Sell online', company: 'Company', resources: 'Resources', contact: 'Contact',
        services: 'Features', links: 'Sales links', api: 'API', docs: 'Documentation',
        pricing: 'Who is it for?', about: 'About', security: 'Security',
        help: 'Help center', faq: 'FAQ', terms: 'Terms of service', privacy: 'Privacy policy',
        rights: 'All rights reserved.' },
      register: { title: 'Create an account', subtitle: 'Create your Biz-transPay workspace and grow your online business with simple tools to sell your offers.',
        full_name: 'Full name', full_name_ph: 'Enter your full name',
        username: 'Username', username_ph: 'Choose a username',
        country: 'Country', country_ph: 'Select your country',
        phone: 'Phone number', phone_ph: '07 12 34 56 78',
        email: 'Email', email_ph: 'example@email.com',
        password: 'Password', password_ph: 'Create a password',
        confirm: 'Confirm password', confirm_ph: 'Confirm your password',
        robot: 'I confirm I am not a robot',
        terms_1: 'I agree to the', terms_link_1: 'Terms of service', terms_and: 'and',
        terms_link_2: 'Privacy policy', terms_end: 'of Biz-transPay.',
        submit: 'Create my account', have_account: 'Already have an account?', login: 'Log in',
        errors: { required: 'This field is required', mismatch: 'Passwords do not match',
          short: 'Minimum 6 characters', terms: 'You must accept the terms', robot: 'Please confirm you are not a robot' } },
      login: { title: 'Log in', subtitle: 'Welcome back! Log in to your Biz-transPay account.',
        identifier: 'Email or username', password: 'Password', submit: 'Log in',
        no_account: "Don't have an account?", register: 'Sign up' },
      dashboard: { title: 'Dashboard', available: 'Available balance',
        transactions: 'Transactions', history: 'History',
         bottom_home: 'Home', services: 'Services', profile: 'Profile',
        payment_link: 'Payment link', api: 'Payment API', kyc: 'KYC Verification',
         fees: 'Fees',
        settings: 'Settings', support: 'Support',
        transfer: 'Transfer', deposit: 'Deposit', link: 'Link', exchange: 'Exchange',
        search_ph: 'Search by payment number, transaction ID, email, Biz-transPay reference or provider reference...',
        kyc_banner_title: 'KYC verification required',
        kyc_banner_body: 'Your account has been created successfully. For security and compliance reasons, you must complete KYC verification before accessing Payment Links and the Payment API.',
        kyc_banner_cta: 'Verify my identity', no_tx: 'No transactions yet', recent_activity: 'Recent activity' },
      transfer: { title: 'New transfer', subtitle: 'Choose the type of transfer you want to make.',
        biz_to_biz: 'Biz-trans → Biz-trans', biz_to_biz_d: 'To another Biz-transPay user',
        biz_to_mobile: 'Biz-trans → Mobile Money', biz_to_mobile_d: 'To a Mobile Money number',
        biz_to_bank: 'Biz-trans → Bank account', biz_to_bank_d: 'To a bank account (IBAN)',
        recipient: 'Recipient',
        recipient_ph_biz: 'Username or email', recipient_ph_mobile: 'Mobile Money number', recipient_ph_bank: 'IBAN / account number',
        recipient_name: 'Recipient name', amount: 'Amount', currency: 'Currency', description: 'Description (optional)',
        confirm: 'Send transfer', success: 'Transfer sent successfully!', fee: 'Fee' },
      deposit: { title: 'Make a deposit', subtitle: 'Top up your Biz-transPay balance via Stripe.',
        method: 'Payment method', card: 'Bank card', card_d: 'Visa, Mastercard, American Express',
        proceed: 'Proceed to payment', min: 'Minimum amount: 300' },
      exchange: { title: 'Currency exchange', subtitle: 'Convert your funds between XOF and XAF.',
        from: 'From', to: 'To', amount: 'Amount', rate: 'Exchange rate', fee: 'Fee', receive: 'You receive',
        confirm: 'Confirm exchange', success: 'Exchange completed successfully!' },
      links: { title: 'Payment links', subtitle: 'Create and manage your payment links.',
        create: 'Create a link', new_title: 'New payment link',
        link_title: 'Link title', link_title_ph: 'Ex: Invoice #001',
        amount: 'Amount', currency: 'Currency', description: 'Description',
        expires: 'Expiration date (optional)', single_use: 'Single-use link',
        generate: 'Generate link', copied: 'Link copied to clipboard',
        no_links: 'No payment links yet', payments: 'payments', active: 'Active', inactive: 'Inactive',
        actions: 'Actions' },
      api: { title: 'Payment API', subtitle: 'Integrate Biz-transPay into your application.',
        public: 'Public key', secret: 'Secret key', webhook: 'Webhook URL', webhook_ph: 'https://yoursite.com/webhook',
        regenerate: 'Regenerate keys', save_webhook: 'Save', copied: 'Copied!', docs: 'API Documentation',
        merchant_only: 'Reserved for merchant accounts. Switch to merchant from Settings.' },
      kyc: { title: 'KYC Verification', subtitle: 'Complete your identity verification to unlock all features.',
        status: 'Status', not_started: 'Not started', pending: 'Pending', verified: 'Verified', rejected: 'Rejected',
        doc_type: 'Document type', id_card: 'ID card', passport: 'Passport', driver: 'Driver\'s license',
        doc_number: 'Document number', doc_front: 'Front', doc_back: 'Back',
        selfie: 'Selfie with document', address_proof: 'Proof of address',
        address: 'Address', city: 'City', submit: 'Submit for verification',
        success: 'KYC submitted and approved!' },
      settings: { title: 'Settings', profile: 'Profile', security_t: 'Security', preferences: 'Preferences',
        full_name: 'Full name', email: 'Email', phone: 'Phone',
        save: 'Save', saved: 'Saved',
        current_pwd: 'Current password', new_pwd: 'New password', change_pwd: 'Change password',
        two_fa: 'Two-factor authentication (2FA)', language: 'Language', default_currency: 'Default currency' },
      support: { title: 'Support', subtitle: 'Our team is here to help.',
        new_ticket: 'New ticket', subject: 'Subject', message: 'Message', category: 'Category',
        submit: 'Send', no_tickets: 'No tickets yet', faq_title: 'Frequently asked questions' },
      fees: { title: 'Platform fees', subtitle: 'Current fees configured for the platform.',
        deposit: 'Deposits', withdrawal: 'Withdrawals', mobile_money: 'Mobile Money',
        crypto: 'Crypto', conversion: 'Conversions', operator: 'Operator',
        asset: 'Asset', fee: 'Fee', limits: 'Limits', no_data: 'No active fee is configured.',
        fixed: 'fixed', from: 'from', to: 'to', unavailable: 'Unavailable' },
      push: {
        title: 'Enable notifications',
        body: 'Enable push notifications to receive important information, updates, and alerts about your Biz-transPay account.',
        allow: 'Enable notifications',
        later: 'Later',
        enabled: 'Notifications enabled',
        error: 'Could not enable notifications. Try again or enable them from your profile.',
        blocked: 'Notifications are blocked in your browser settings. Allow them in your browser, then try again from your profile.',
      },
      common: { back: 'Back', next: 'Next', cancel: 'Cancel', confirm: 'Confirm', copy: 'Copy', logout: 'Log out' },
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem('btp_lang') || 'fr',
  fallbackLng: 'fr',
  interpolation: { escapeValue: false },
});

export default i18n;
